<div data-screen *ngIf="visible">
  <mat-spinner color="primary" [diameter]="45"></mat-spinner>
  <div>{{ message }}</div>
</div>

<ng-content></ng-content>
